export default class OpsStringUtils {
  public static capitalize = (str: string) => {
    const lower = str.toLowerCase();
    return str.charAt(0).toUpperCase() + lower.slice(1).replace("_", " ");
  };

  public static handlePlural = (instance: number, message: string) => {
    if (instance === 1) {
      return message.slice(0, -1);
    }
    return message;
  };

  /** Initials from a full name */
  public static getInitials = (name: string): string => {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) {
      return "";
    }
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
  };

  public static lowerStrUpperFirstLetter = (str: string) => {
    let words = str.toLowerCase().split(/[\s_]+/);

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    let convertedStr = words.join(" ");
    return convertedStr;
  };
}
